var React = require('react');

function Omnibox (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.5 14.95h-.95l-.34-.32a7.78 7.78 0 1 0-.84.84l.33.33v.95l5.98 5.97 1.79-1.79-5.97-5.98zm-7.19 0A5.38 5.38 0 1 1 9.3 4.19a5.38 5.38 0 0 1 .01 10.76z","key":0}),React.createElement("path",{"opacity":".5","d":"M13.13 9.12a3.8 3.8 0 0 0-3.35-3.35V4.9h-.84v.87a3.8 3.8 0 0 0-3.35 3.35h-.87v.84h.87a3.8 3.8 0 0 0 3.35 3.35v.87h.84v-.87a3.8 3.8 0 0 0 3.35-3.35H14V9.1h-.87zm-3.77 3.37a2.95 2.95 0 1 1 0-5.9 2.95 2.95 0 0 1 0 5.9z","key":1}),React.createElement("circle",{"cx":"9.38","cy":"9.56","r":".75","key":2})]);
}

Omnibox.displayName = "Omnibox";

Omnibox.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Omnibox;

Omnibox.default = Omnibox;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Omnibox.svg
// module id = 648
// module chunks = 168707334958949